import federation from '/workspace/inflearn-next-frontend/node_modules/.pnpm/@module-federation+webpack-bundler-runtime@0.1.8/node_modules/@module-federation/webpack-bundler-runtime/dist/index.cjs.js';
import plugin_0 from '/workspace/inflearn-next-frontend/node_modules/.pnpm/@module-federation+nextjs-mf@8.3.9_next@13.4.9_react-dom@18.2.0_react@18.2.0_typescript@4.8.4_x34rmnt7q5ktaeqnxsfs4ysa44/node_modules/@module-federation/nextjs-mf/dist/src/plugins/container/runtimePlugin.js';

var prevFederation = __webpack_require__.federation;
__webpack_require__.federation = {}
for(var key in federation){
	__webpack_require__.federation[key] = federation[key];
}
for(var key in prevFederation){
	__webpack_require__.federation[key] = prevFederation[key];
}
if(!__webpack_require__.federation.instance){
	const pluginsToAdd = [
		plugin_0 ? plugin_0() : false,
	].filter(Boolean);
	__webpack_require__.federation.initOptions.plugins = __webpack_require__.federation.initOptions.plugins ? 
	__webpack_require__.federation.initOptions.plugins.concat(pluginsToAdd) : pluginsToAdd;
	__webpack_require__.federation.instance = __webpack_require__.federation.runtime.init(__webpack_require__.federation.initOptions);
	if(__webpack_require__.federation.attachShareScopeMap){
		__webpack_require__.federation.attachShareScopeMap(__webpack_require__)
	}
	if(__webpack_require__.federation.installInitialConsumes){
		__webpack_require__.federation.installInitialConsumes()
	}
}